import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import './assets/css/animations.css';
import Home from './components/pages/Home';
import Services from './components/pages/Services';
import About from './components/pages/About';
import LegalAndPolices from './components/pages/LegalAndPolices';
import Contact from './components/pages/Contact';
import CookieConsent from './components/commonComponents/CookieConsent';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/legal_and_polices" element={<LegalAndPolices />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} theme="dark" />
    </div>
  );
}

export default App;
